import { jsx } from "react/jsx-runtime";
import React__default from "react";
import { AnalyticsId } from "./constants.js";
import styles from "./components/HelpTooltip/HelpTooltipWord/styles.module.scss";
const HelpTooltipWord = React__default.forwardRef(
  ({ children, onClick, onFocus, onBlur, onKeyDown, testId, ariaDescribedById }, ref) => /* @__PURE__ */ jsx(
    "button",
    {
      className: styles.word,
      ref,
      onClick,
      onMouseEnter: onFocus,
      onMouseLeave: onBlur,
      onFocus,
      onBlur,
      onKeyDown,
      "aria-describedby": ariaDescribedById,
      "data-testid": testId,
      "data-analyticsid": AnalyticsId.HelpTooltip,
      children
    }
  )
);
HelpTooltipWord.displayName = "TooltipWord";
export {
  HelpTooltipWord as H
};
//# sourceMappingURL=HelpTooltipWord.js.map
